import React from "react"
import { ArrowDropDown, Circle } from "@mui/icons-material"
import { AppBar, Autocomplete, Box, Button, Grid, IconButton, Paper, Popover, Slide, TextField, Typography, useScrollTrigger } from "@mui/material"
import { isMobile } from "react-device-detect"
import ResetToken from "../documents/ResetToken"
import { enqueueSnackbar } from "notistack"
import useConfirm from "../utils/useConfirm"
import { customFetch } from "../utils/functions"
import BrandingService from "../branding/BrandingService"

export default function Searchbar({ merchants, merchant, setMerchant }) {
  const trigger = useScrollTrigger({ disableHysteresis: true })
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [getConfirmation, Confirmation] = useConfirm()

  function logout() {
    sessionStorage.removeItem("token")
    sessionStorage.removeItem("merchants")
    sessionStorage.removeItem("username")
    sessionStorage.removeItem("role")
    sessionStorage.removeItem("agentID")
    window.location.href = "/login"
  }

  async function changePassword() {
    const confirmation = await getConfirmation("Are You Sure?", "You will be logged out and receive further instructions in the email associated with this account.")
    if (confirmation) {
      const email = localStorage.getItem("loginEmail")
      const resetToken = new ResetToken(email)

      // Push Token to Database
      customFetch("POST", `${process.env.REACT_APP_API}/api/mongo/add-document/ResetToken`, resetToken)

      // Send Password Reset Email
      const { response } = await customFetch("POST", `${process.env.REACT_APP_API}/api/communications/email-template`, {
        app: BrandingService.current.id,
        template: "changepassword",
        recipient: email,
        subject: "Reef Pay Password Reset",
        data: { origin: process.env.REACT_APP_URL, token: resetToken.token }
      })

      if (response.status === 200) {
        enqueueSnackbar(`Sent password reset instructions to ${email}.`, { variant: "success" })
        logout()
      } else enqueueSnackbar("Failed to send password reset instructions.", { variant: "error" })
    }
  }

  return (
    <>
      <Slide appear={true} direction="down" in={!trigger || !isMobile}>
        <AppBar position="sticky" elevation={1} sx={{ bgcolor: "primary.contrastText" }}>
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid size={{ xs: 10, sm: 6, md: 4 }}>
              <Autocomplete
                autoHighlight
                disableClearable
                options={merchants}
                getOptionLabel={option => option.dba || "..."}
                value={merchant}
                popupIcon={<ArrowDropDown color="primary" />}
                onChange={(event, value) => {
                  if (value === null) return
                  setMerchant(value)
                  localStorage.setItem("lastMid", value.mid)
                }}
                renderOption={(props, option) => (
                  <li {...props} key={option.mid}>
                    {option.dba}
                  </li>
                )}
                renderInput={params => (
                  <TextField
                    {...params}
                    variant="standard"
                    placeholder="No Store Selected"
                    onFocus={event => event.target.select()}
                    InputProps={{
                      ...params.InputProps,
                      disableUnderline: true,
                      sx: {
                        paddingLeft: 5,
                        color: "primary.main",
                        textAlign: "left",
                        fontWeight: "bold",
                        fontSize: 20
                      }
                    }}
                  />
                )}
              />
            </Grid>
            <Grid container alignItems="center" justifyContent="flex-end" size={{ xs: 2, sm: 6 }}>
              <Grid>
                <IconButton
                  onClick={event => setAnchorEl(anchorEl ? null : event.currentTarget)}
                  tabIndex={-1}
                  sx={{ display: "grid" }}
                >
                  <Circle color="primary" sx={{ fontSize: 52, gridColumn: 1, gridRow: 1 }} />
                  <Typography variant="h4" color="primary.contrastText" fontWeight="bold" sx={{ gridColumn: 1, gridRow: 1 }}>
                    {sessionStorage.getItem("username").charAt(0).toUpperCase()}
                  </Typography>
                </IconButton>
                <Popover open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={() => setAnchorEl(null)}>
                  <Box padding={1} component={Paper}>
                    <Typography variant="h6" fontWeight="bold">{sessionStorage.getItem("username")}</Typography>
                    <Typography>{localStorage.getItem("loginEmail")}</Typography>
                    <Button variant="text" onClick={changePassword}>
                      Change Password
                    </Button>
                    <Button
                      variant="text"
                      color="error"
                      onClick={logout}
                    >
                      Logout
                    </Button>
                  </Box>
                </Popover>
              </Grid>
            </Grid>
          </Grid>
        </AppBar>
      </Slide>
      <Confirmation />
    </>
  )
}